var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("label", { attrs: { for: "sort-by" } }, [_vm._v("Sort by")]),
    _vm._v(" "),
    _c(
      "select",
      {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.sortBy,
            expression: "sortBy"
          }
        ],
        attrs: { id: "sort-by" },
        on: {
          change: [
            function($event) {
              var $$selectedVal = Array.prototype.filter
                .call($event.target.options, function(o) {
                  return o.selected
                })
                .map(function(o) {
                  var val = "_value" in o ? o._value : o.value
                  return val
                })
              _vm.sortBy = $event.target.multiple
                ? $$selectedVal
                : $$selectedVal[0]
            },
            _vm.change
          ]
        }
      },
      [
        _c("option", { attrs: { value: "manual" } }, [_vm._v("Featured")]),
        _vm._v(" "),
        _c("option", { attrs: { value: "price-ascending" } }, [
          _vm._v("Price: Low to High")
        ]),
        _vm._v(" "),
        _c("option", { attrs: { value: "price-descending" } }, [
          _vm._v("Price: High to Low")
        ]),
        _vm._v(" "),
        _c("option", { attrs: { value: "title-ascending" } }, [_vm._v("A-Z")]),
        _vm._v(" "),
        _c("option", { attrs: { value: "title-descending" } }, [_vm._v("Z-A")]),
        _vm._v(" "),
        _c("option", { attrs: { value: "created-ascending" } }, [
          _vm._v("Oldest to Newest")
        ]),
        _vm._v(" "),
        _c("option", { attrs: { value: "created-descending" } }, [
          _vm._v("Newest to Oldest")
        ]),
        _vm._v(" "),
        _c("option", { attrs: { value: "best-selling" } }, [
          _vm._v("Best Selling")
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }